import React from 'react';
import { Badge, Card } from 'antd';
import { Clock, Warning2, UserRemove, DollarCircle } from 'iconsax-react';
import './NotificationsCard.css';
import { ExclamationCircleOutlined } from '@ant-design/icons';

type NotificationType = 'warning' | 'danger' | 'info' | 'error';
type IconType = 'clock' | 'warning' | 'user' | 'dollar';

interface Notification {
  id: string | number;
  type: NotificationType;
  text: string;
  icon: IconType;
}

interface NotificationsCardProps {
  notifications: Notification[];
  comingSoon?: boolean;
}

const NotificationsCard: React.FC<NotificationsCardProps> = ({ notifications, comingSoon }) => {
  const getIconColor = (type: NotificationType): string => {
    switch (type) {
      case 'warning':
        return '#f59e0b';
      case 'danger':
      case 'error':
        return '#ef4444';
      case 'info':
        return '#3b82f6';
      default:
        return '#94a3b8';
    }
  };

  const renderIcon = (iconType: IconType, color: string) => {
    switch (iconType) {
      case 'clock':
        return <Clock size={16} color={color} variant="Linear" />;
      case 'warning':
        return <Warning2 size={16} color={color} variant="Linear" />;
      case 'user':
        return <UserRemove size={16} color={color} variant="Linear" />;
      case 'dollar':
        return <DollarCircle size={16} color={color} variant="Linear" />;
      default:
        return null;
    }
  };

  return (
    <Card className={`notifications-card ${comingSoon ? 'notifications-card--coming-soon' : ''}`}>
      <div className="notifications-card__header">
        <div className="notifications-card__icon-wrapper">
          <ExclamationCircleOutlined style={{ fontSize: 24, color: '#10b981' }} />
        </div>
        <span className="notifications-card__title">NOTIFICATIONS IMPORTANTES</span>
        {comingSoon && <Badge count="Soon" className="soon-badge" />}
      </div>
      <div className="notifications-card__list">
        {notifications.map((notif) => (
          <div
            key={notif.id}
            className={`notifications-card__item notifications-card__item--${notif.type}`}
          >
            {renderIcon(notif.icon, getIconColor(notif.type))}
            <span>{notif.text}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default NotificationsCard;
